import { webSafeFonts } from "@schaniag/private";
import { getRandomStringsAndNumbers } from "../random/randomStrings";
import { SmetioFileUploader } from "../../../app";
export const getAndUploadCssFileToGoogleStorage = async (functionParameters={})=> {

    const colorVariablesAndThemesStyles = localStorage.getItem("cssCodeForFile");

    console.log(" colorVariablesAndThemesStyles is ", colorVariablesAndThemesStyles);

    if(!colorVariablesAndThemesStyles) return false;

    let {smetioPresentationClass,  cssFileName, brandTypography, preloaderClass, smartbox, textClass, brandAccentColor, model, uniqueValues, titleClass, subTitleClass, paragraphClass } = functionParameters;

    let {primaryFont, secondaryFont} = brandTypography;

    if (!preloaderClass) {
        preloaderClass = {
            show: () => { console.log("using fake show");  },
            hide: ()=>{ console.log("using fake hide"); }
        };
    };
      
    preloaderClass.show();

    // $('.'+preloaderClass).attr("data-smetio-is-visible", true);
    
    const primaryFontObj = webSafeFonts[primaryFont];

    const fontFamily = primaryFontObj["classification"];

    primaryFont = primaryFont.split(" ").length > 1 ? `"${primaryFont}"` : primaryFont;
    secondaryFont = secondaryFont.split(" ").length > 1 ? `"${secondaryFont}"` : secondaryFont;

    const cssFileContent = `
        *{
            font-family: ${primaryFont}, ${secondaryFont}, ${fontFamily} !important;
        }

        ${colorVariablesAndThemesStyles}
    `;

    console.log("cssFileContent is ", cssFileContent);

    const cssMinify = (await import(/* webpackPrefetch: true */ "csso") ).minify;

    const cssFileContentMinified = cssMinify(cssFileContent).css;
    
    const fileName = cssFileName || getRandomStringsAndNumbers(10)+".css";


    const newFile = new File([cssFileContentMinified], fileName, {
        type: "text/css",
    });

    const signedUrlEndpoint = `${window.apiEndPoint}/signedUrl/upload/css/${window.userLanguage}`;

    console.log("signedUrlEndpoint is ", signedUrlEndpoint);

    let fileUploader = new SmetioFileUploader({
        subfolder: "",
        // signedUrlEndpoint: `http://localhost:4000/api/signedUrl/upload/css/${window.smetioVisitor.language}`,
        // this.signedUrlEndpoint = `${window.apiEndPoint}/signedUrl/upload/img/${window.userLanguage}`;
        // signedUrlEndpoint: `${window.apiEndPoint}/signedUrl/upload/css/${window.userLanguage}`,      
        signedUrlEndpoint,      
        events: {
            onFileUploaded: ({ signedUrl, cdnPath }) => {

                // $('.'+preloaderClass).attr("data-smetio-is-visible", false);
                // preloaderClass.hide();

                localStorage.removeItem("cssCodeForFile");
                
                fileUploader = null;
            },
            onAllFileIsUploaded: ({ files }) => {

            },
        }
    });

    fileUploader.preloader = preloaderClass;
    // fileUploader.render();
    fileUploader.fileAreDroppedDragZone(null, newFile);
    
    setTimeout(() => {

        const fileHash = Object.keys(fileUploader.files)[0];

        fileUploader.uploadFile({ fileHash });

    }, 300);

    // setTimeout(() => {

    //     preloaderClass.hide();

    // }, 1000);
    
    const subTitle = `${window["smetioTexts"]["txt471"]}: ${primaryFont} `;
    const paragraph = `
        <span style="display: flex; flex-direction: row; align-items: flex-start; justify-content: center;">
            <span style="min-width: 20px; width: 20px; min-height: 20px; height: 20px; background-color:${brandAccentColor.code}"></span>
            <span style="flex: 1; text-align: left;" > ${window["smetioTexts"]["txt456"]}: ${brandAccentColor.code}</span>
        </span>
    `;

    if (smetioPresentationClass) {
        smetioPresentationClass.changeSubtitle(subTitle);
        smetioPresentationClass.changeParagraph(paragraph);
    };

    if(preloaderClass) preloaderClass.hide();


    // $(`.${subTitleClass}`).html(subTitle);
    // $(`.${paragraphClass}`).html(paragraph);
    // $(`.${paragraphClass}`).remove();
    // $('.'+preloaderClass).attr("data-smetio-is-visible", false);

    // $(`.${textClass}`).append(paragraph);

    // console.log("subTitleClass is ", subTitleClass);
    // console.log("paragraphClass is ", paragraphClass);

    // console.log("subTitle is ", subTitle);
    // console.log("paragraph is ", paragraph);

    

    /* 
        primaryFont: formData.primaryFont,
        secondaryFont: formData.secondaryFont
*/

    // console.log("message from getAndUploadCssFileToGoogleStorage.js ", functionParameters);
};
